// src/components/ProtectedLayout.js

import React from 'react';
import Navbar from './Navbar';
import { Outlet, Navigate } from 'react-router-dom';

function ProtectedLayout() {
  const token = localStorage.getItem('accessToken');

  // Si no hay token, redirige al usuario a la página de login
  if (!token) {
    return <Navigate to="/login" />;
  }

  return (
    <div className="flex flex-col min-h-screen bg-fondo font-sans">
      <Navbar />
      <main className="flex-grow">
        {/* Aquí se renderizará el contenido de la página actual (ej. DashboardPadre) */}
        <Outlet /> 
      </main>
    </div>
  );
}

export default ProtectedLayout;